import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValidationMessageModel } from '@data-layer/models/common';
import { enumValidationMessageSeverity } from '@data-layer/enums/common';
import { EntityModel } from '@data-layer/models/entities';
import { omit } from 'lodash-es';
import { ValidationI18nMapperService } from '@shared/missing-fields/services/validation-i18n-mapper.service';

@Component({
  selector: 'missing-fields',
  templateUrl: './missing-fields.component.html',
  styleUrls: ['./missing-fields.component.scss'],
})
export class MissingFieldsComponent {
  @Input() public canDecline = true;
  @Input() public canConfirm = true;
  @Input() public code: 'LABELS.ISF' | 'LABELS.ENTRY_SUMMARY' | 'MENU.CREATE_COMPANY' | 'MENU.DELIVERY_ORDER' = 'LABELS.ISF';
  @Input() public title = 'INCORRECT_INFORMATION.TITLE';
  @Input() public descriptionText1 = 'INCORRECT_INFORMATION.TEXT_1';
  @Input() public descriptionText2 = 'INCORRECT_INFORMATION.TEXT_2';
  @Input() public declineTitle = 'CONTINUE_EDIT_LATER';
  @Input() public confirmTitle = 'EDIT_NOW';
  @Input() public showErrorKey: boolean = true;
  @Input() public showErrorTitle: boolean = false;
  @Input() public showErrorIcon: boolean = false;
  @Output() public confirm: EventEmitter<any> = new EventEmitter<any>();
  @Output() public decline: EventEmitter<any> = new EventEmitter<any>();

  public backError: any[] = [];
  public isModalOpen = false;
  public enumValidationMessageSeverity: typeof enumValidationMessageSeverity = enumValidationMessageSeverity;

  constructor(private validationI18nMapperService: ValidationI18nMapperService) {}

  public openCustomModal(validationMessages: [{ [key: string]: ValidationMessageModel }]) {
    // #13269 — an entry may carry its own labelKey (+ translate params), e.g. "Beneficial Owner #2: …"
    this.backError = Object.keys(validationMessages).map((v) => ({
      key: validationMessages[v]?.labelKey || this.validationI18nMapperService.mapValidationStr(`FORM_LABEL.${v.toLocaleUpperCase()}`),
      keyParams: validationMessages[v]?.keyParams,
      title: `BACK_ERROR.${validationMessages[v].text}`,
    }));

    this.isModalOpen = true;
  }

  public openCustomModalNewEntity(validationMessages: ValidationMessageModel[]) {
    this.backError = validationMessages.map((v) => ({
      key: this.validationI18nMapperService.mapValidationStr(`FORM_LABEL.${v.text.toLocaleUpperCase()}`),
      title: `BACK_ERROR.${v.text}`,
      params: v.params,
      severity: v.severity,
    }));

    this.isModalOpen = true;
  }

  public openModal(isfEntity: EntityModel) {
    const validationMessage = omit(isfEntity.validationMessages, 'hts');
    this.backError = Object.keys(validationMessage).map((v) => ({
      key: this.validationI18nMapperService.mapValidationStr(`FORM_LABEL.${v.toLocaleUpperCase()}`),
      title: `BACK_ERROR.${validationMessage[v].text}`,
    }));

    if (isfEntity && !!isfEntity['address']) {
      const validationMessageAddress: [{ [key: string]: ValidationMessageModel }] = isfEntity['address'].validationMessages;
      Array.prototype.push.apply(
        this.backError,
        Object.keys(validationMessageAddress).map((v) => ({
          key: this.validationI18nMapperService.mapValidationStr(`FORM_LABEL.${v.toLocaleUpperCase()}`),
          title: `BACK_ERROR.${validationMessageAddress[v].text}`,
        })),
      );
    }

    this.isModalOpen = true;
  }

  public onConfirm(): void {
    this.isModalOpen = false;
    this.confirm.emit();
  }

  public onDecline(): void {
    this.isModalOpen = false;
    this.decline.emit();
  }

  public destroyModal(): void {
    this.isModalOpen = false;
  }
}
